// import HERO_SECTION_IMAGE from "../assets/Hero/hero1.png";
import "../style/HeroStyle.css";
import { motion } from "framer-motion";


const TopSection = () => {
    // Animation variants
    const fadeInUp = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0 }
    };

    // const floatAnimation = {
    //     y: [0, -10, 0],
    //     transition: {
    //         duration: 3,
    //         repeat: Infinity,
    //         ease: "easeInOut"
    //     }
    // };

  

    // Profession badges data

    return (
        <section
            className="pt-4"
            style={{
                backgroundColor: "#f9fafb",
            }}
        >
            <div className="container">
                <div className="d-flex col align-items-center justify-content-center">
                    {/* Left Content */}
                    <div className="col align-items-center">
                        <motion.div
                            className=" text-center"
                            initial="hidden"
                            animate="visible"
                            variants={{
                                visible: {
                                    transition: {
                                        staggerChildren: 0.15
                                    }
                                }
                            }}
                        >
                           
{/* 
                            <motion.h1
                                className="fw-bolder mb-5 fs-3 text-center"
                                variants={fadeInUp}
                            >
                                Meet DayDone
                            </motion.h1> */}
                            <motion.h1
                                className="fw-bold pt-4 fs-3 text-center"
                                variants={fadeInUp}
                            >
                                Run Your Jobs, Team & Payments <br />
                                <p className="highlight-text fs-3">All From One Dashboard</p>
                            </motion.h1>


                        </motion.div>
                    </div>
                </div>
            </div >
        </section >
    );
};

export default TopSection;